var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-select',{staticClass:"ts-w-full",attrs:{"options":_vm.counterList,"showSearch":"","filterOption":function (input, option) { return option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0; }},model:{value:(_vm.model.counter_id),callback:function ($$v) {_vm.$set(_vm.model, "counter_id", $$v)},expression:"model.counter_id"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }